/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsTestimonials = {
    init: function ($section) {
      const $testimonialSlider = $section.find('[data-slider]');

      $testimonialSlider.flickity({
        wrapAround: true,
        initialIndex: 1,
        prevNextButtons: true,
        pageDots: true,
        arrowShape: arrowShape,
        watchCSS: true
      });

      // Resize flickity when the slider is settled
      $testimonialSlider.on('settle.flickity', function () {
        $testimonialSlider.flickity('resize');
      });

      $section.on('click', '.testimonial__nav--prev', function () {
        $testimonialSlider.flickity('previous');
      });

      $section.on('click', '.testimonial__nav--next', function () {
        $testimonialSlider.flickity('next');
      });

      // OnClick Play Video
      $('.play-icon').on('click', function() {
        $(this).hide();
        $(this).prev(".video").attr("controls", "controls");
        var video = $(this).siblings('.video')[0]; // Find the sibling video element within the same block
        video.play();
      });

      $(document).on('scroll', function(){
        $section.each(function() {                                           
            var scrollPosition = $(document).scrollTop();
            var triggerPosition = $section.find('.container').offset().top;

            var bottom_left_position = parseInt($section.find('.testi-bl').data('bottom-left-position'));
            var bottom_right_position = parseInt($section.find('.testi-br').data('bottom-right-position'));
                        
            // Check if the scroll position passes the trigger position
            if (scrollPosition >= triggerPosition) {
                var distanceFromBottom = scrollPosition - triggerPosition;
                var imageBottomLeft;
                var imageBottomRight;
      
                if (distanceFromBottom <= 300) {                    
                    imageBottomLeft = -100 + (60 / 100) * distanceFromBottom;
                    imageBottomRight = -100 + (60 / 100) * distanceFromBottom;
                } else {                    
                    imageBottomLeft = bottom_left_position;
                    imageBottomRight = bottom_right_position;
                }

                $section.find('.testi-bl').css({
                    "bottom": imageBottomLeft + "px",
                    "opacity": 1
                });
                $section.find('.testi-br').css({
                    "bottom": imageBottomLeft + "px",
                    "opacity": 1
                });
            }
          
        });  

        // Mobile
         $section.each(function() {                                           
            var scrollPositionMob = $(document).scrollTop();
            var triggerPositionMob = $section.find('.container').offset().top;
        
            var bottom_left_m_position = parseInt($section.find('.testi-bl-m').data('bottom-left-m-position'));
            var bottom_right_m_position = parseInt($section.find('.testi-br-m').data('bottom-right-m-position'));
                        
            // Check if the scroll position passes the trigger position
            if (scrollPositionMob >= triggerPositionMob) {
                var distanceFromBottomMob = scrollPositionMob - triggerPositionMob;
                var imageBottomLeftMob;
                var imageBottomRightMob;
        
                if (distanceFromBottomMob <= 600) {                    
                    imageBottomLeftMob = -300 + (200 / 300) * distanceFromBottomMob;
                    imageBottomRightMob = -300 + (200 / 300) * distanceFromBottomMob;
                } else {                    
                    imageBottomLeftMob = bottom_left_m_position;
                    imageBottomRightMob = bottom_right_m_position;
                }
        
                $section.find('.testi-bl-m').css({
                    "bottom": imageBottomLeftMob + "px",
                    "opacity": 1
                });
                $section.find('.testi-br-m').css({
                    "bottom": imageBottomLeftMob + "px",
                    "opacity": 1
                });
            }
          
        });  
    });
      
    },
    blockSelect: function ($section, blockId) {
      const $testimonialSlider = $section.find('[data-slider]');

      const slideIndex = $('#shopify-section-' + blockId).data('index');

      $testimonialSlider.flickity('select', slideIndex);
    },
    unload: function ($section) {
      const $slider = $section.find('.flickity-enabled');
      $slider.flickity('destroy');
      $('.testimonial__nav--prev').off();
      $('.testimonial__nav--next').off();
    }
  }

  /******/
})()
  ;